/**
 * Store module — OrderWorkflows
 *
 * Cache des configurations de workflow chargées depuis l'API.
 * Utilisé par l'Admin_UI pour configurer les workflows par type/fournisseur.
 */
import { orderWorkflowsService } from '@/services'
import logger from '@/utils/logger'

const orderWorkflows = {
  strict: true,
  namespaced: true,

  state: {
    configurations: [],
    loaded: false,
  },

  getters: {
    getConfigurations: (state) => state.configurations,
    isLoaded: (state) => state.loaded,

    /**
     * Trouve une configuration par type + fournisseur + migration_type_list + migration_type.
     */
    findConfig: (state) => ({ type, fournisseur, migration_type_list = null, migration_type = null, livraison = null, typeequipement = null, modepaiement = null }) => { // eslint-disable-line camelcase
      if (!state.configurations || !Array.isArray(state.configurations)) return null
      return state.configurations.find(c =>
        c.type === type &&
        c.fournisseur === fournisseur &&
        c.livraison === livraison &&
        c.mode_paiement === modepaiement && // eslint-disable-line camelcase
        c.type_equipement === typeequipement && // eslint-disable-line camelcase
        c.migration_type === migration_type && // eslint-disable-line camelcase
        JSON.stringify(c.migration_type_list) === JSON.stringify(migration_type_list), // eslint-disable-line camelcase
      ) || null
    },
  },

  mutations: {
    SET_CONFIGURATIONS (state, configurations) {
      state.configurations = configurations
      state.loaded = true
    },
    INVALIDATE_CACHE (state) {
      state.configurations = []
      state.loaded = false
    },
    ADD_CONFIGURATION (state, config) {
      if (!Array.isArray(state.configurations)) state.configurations = []
      state.configurations.push(config)
    },
    UPDATE_CONFIGURATION (state, updated) {
      if (!Array.isArray(state.configurations)) state.configurations = []
      const index = state.configurations.findIndex(c => c.id === updated.id)
      if (index !== -1) {
        state.configurations.splice(index, 1, updated)
      }
    },
    REMOVE_CONFIGURATION (state, id) {
      if (!Array.isArray(state.configurations)) state.configurations = []
      state.configurations = state.configurations.filter(c => c.id !== id)
    },
  },

  actions: {
    async fetchConfigurations ({ commit }) {
      try {
        const data = await orderWorkflowsService.list()
        commit('SET_CONFIGURATIONS', data)
        return data
      } catch (error) {
        logger.error('Erreur chargement configurations workflow:', error)
        throw error
      }
    },

    async saveConfiguration ({ commit }, configuration) {
      try {
        if (configuration.id) {
          const data = await orderWorkflowsService.update(configuration, configuration.id)
          commit('UPDATE_CONFIGURATION', data)
          return data
        }
        const data = await orderWorkflowsService.save(configuration)
        commit('ADD_CONFIGURATION', data)
        return data
      } catch (error) {
        logger.error('Erreur sauvegarde configuration workflow:', error)
        throw error
      }
    },

    async deleteConfiguration ({ commit }, id) {
      try {
        await orderWorkflowsService.remove(id)
        commit('REMOVE_CONFIGURATION', id)
      } catch (error) {
        logger.error('Erreur suppression configuration workflow:', error)
        throw error
      }
    },
  },
}

export default orderWorkflows
